import { Series } from 'remotion';
import {
  MarriageBrideDetails,
  MarriageGroomDetails,
  MarriageMessage,
  MarriageTiming,
  MarriageTitle,
  MarriageVenue,
  MarriageWelcome
} from './MarriageComponents';

interface Props {
  props: any;
  labels: any;
  color: string;
  image?: any;
  className?: string;
}

const MarriageInvitationTemplate = (prop: Props) => {
  const { props, labels, color, image = null, className = '' } = prop;

  return (
    <Series>
      <Series.Sequence durationInFrames={70}>
        <MarriageWelcome props={props} labels={labels} color={color} image={image} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={80}>
        <MarriageTitle props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={130}>
        <MarriageMessage props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={130}>
        <MarriageGroomDetails props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={130}>
        <MarriageBrideDetails props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={90}>
        <MarriageTiming props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
      <Series.Sequence durationInFrames={90}>
        <MarriageVenue props={props} labels={labels} color={color} className={className} />
      </Series.Sequence>
    </Series>
  );
};

export default MarriageInvitationTemplate;
